// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"3cc710ff","241":"a9f98f34","262":"7da8af74","491":"6d4b95a6","686":"bd76a36d","736":"52f0efe8","942":"f62b53a9","946":"d4581f64"}[chunkId] + ".chunk.js";
};